import { Link } from "react-router-dom";
import { Sparkles, Target, Swords, GitBranch, Trophy, Bot, BookOpen, Users, Rocket, CalendarCheck, Crown, Zap } from "lucide-react";
import LandingShell from "../components/LandingShell";
import Btn from "../components/Btn";

const HIGHLIGHTS = [
  {
    icon: Target, color: "var(--su-energy)", img: "/features/tryout.png",
    title: "Tryout SKD & SNBT — CBT Mirip Asli",
    desc: "Sistem CBT dirancang menyerupai ujian sungguhan: timer per sesi, navigasi soal, IRT SNBT & passing grade CPNS. Soal diambil dari bank soal sehingga tryout bisa dikerjakan berkali-kali dan selalu berbeda tiap kali.",
  },
  {
    icon: Swords, color: "var(--su-primary)", img: "/features/arena.png",
    title: "1v1 Quiz Arena",
    desc: "Tantang pengguna lain secara real-time, adu cepat & tepat menjawab soal. Menang untuk menaikkan ELO dan panjat papan peringkat mingguan.",
  },
  {
    icon: GitBranch, color: "var(--su-success)", img: "/features/skilltree.png",
    title: "Sistem Skill Tree",
    desc: "Peta kemampuan per materi yang memvisualkan kekuatan dan kelemahanmu — sehingga kamu tahu persis bagian mana yang perlu diperkuat.",
  },
  {
    icon: Trophy, color: "var(--su-secondary)", img: "/features/ranking.png",
    title: "Sistem Peringkat Tiap Tryout",
    desc: "Setiap tryout (kecuali Drill Kilat) memiliki peringkat: begitu selesai, kamu langsung tahu posisimu dibanding peserta lain lengkap dengan papan peringkat.",
  },
];

const OTHERS = [
  { icon: Bot, title: "AI Personal Mentor", desc: "AI membedah tiap soal salah langkah demi langkah." },
  { icon: BookOpen, title: "Modul Materi", desc: "Rangkuman TWK, TIU, TKP, PU, PPU, PBM & PK." },
  { icon: Users, title: "Study Guild", desc: "Belajar bareng, chat real-time, & menangkan Guild War." },
  { icon: Rocket, title: "Tryout Akbar", desc: "Simulasi serentak nasional dengan hadiah nyata." },
  { icon: CalendarCheck, title: "Misi Harian", desc: "Klaim token, energi & EXP tiap hari, jaga streak." },
  { icon: Crown, title: "RPG Progression", desc: "EXP, level, badge langka, energi & token." },
  { icon: Zap, title: "Drill Kilat", desc: "Latihan cepat fokus satu materi untuk pemanasan." },
  { icon: Sparkles, title: "AI Question Generator", desc: "Bank soal HOTS terus bertambah, termasuk figural." },
];

function Shot({ src, alt }) {
  return (
    <div className="rounded-2xl overflow-hidden border-2 border-su-border shadow-[0_6px_0_var(--su-border)] bg-su-bg">
      <img src={src} alt={alt} loading="lazy"
        onError={(e) => { e.currentTarget.style.display = "none"; }}
        className="w-full h-auto object-cover" />
    </div>
  );
}

export default function Fitur() {
  return (
    <LandingShell wide title="Fitur SkorUp.io" icon={Sparkles}
      subtitle="Semua yang kamu butuhkan untuk menaklukkan ujian — dengan empat fitur unggulan yang bikin beda.">
      <div className="space-y-16" data-testid="fitur-page">
        {/* highlights with screenshots */}
        <div className="space-y-12">
          {HIGHLIGHTS.map((f, i) => (
            <div key={f.title} className={`grid lg:grid-cols-2 gap-8 items-center ${i % 2 ? "lg:[&>*:first-child]:order-2" : ""}`} data-testid={`fitur-highlight-${i}`}>
              <div>
                <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full font-heading font-black text-xs mb-3" style={{ background: `${f.color}22`, color: f.color }}>
                  <f.icon className="w-4 h-4" /> Fitur Unggulan
                </span>
                <h2 className="font-heading font-black text-2xl sm:text-3xl mb-3">{f.title}</h2>
                <p className="text-su-muted font-medium leading-relaxed">{f.desc}</p>
              </div>
              <Shot src={f.img} alt={f.title} />
            </div>
          ))}
        </div>

        {/* all other features */}
        <div>
          <h2 className="font-heading font-black text-2xl sm:text-3xl text-center mb-2">Dan Masih Banyak Lagi</h2>
          <p className="text-su-muted font-medium text-center mb-8">Fitur lengkap lainnya yang bikin belajar makin efektif.</p>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {OTHERS.map((f) => (
              <div key={f.title} className="card-chunky p-6" data-testid={`fitur-other-${f.title}`}>
                <div className="w-12 h-12 rounded-2xl bg-su-primary/12 grid place-items-center mb-3"><f.icon className="w-6 h-6 text-su-primary" /></div>
                <h3 className="font-heading font-black text-base mb-1">{f.title}</h3>
                <p className="text-su-muted font-medium text-sm">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center">
          <Link to="/auth"><Btn size="lg" data-testid="fitur-cta">Coba Semua Fitur Gratis</Btn></Link>
        </div>
      </div>
    </LandingShell>
  );
}
